import { createSelector } from 'reselect';

export const getUnexpectedRewardsSelector = createSelector(
  [state => state.unexpectedRewards.reward],
  reward => reward,
);
